import { render, staticRenderFns } from "./StudentByItemApexChart.vue?vue&type=template&id=0b0d2886&"
import script from "./StudentByItemApexChart.vue?vue&type=script&lang=js&"
export * from "./StudentByItemApexChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports